import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gracias',
  templateUrl: './gracias.component.html',
  styleUrls: ['./gracias.component.css']
})
export class GraciasComponent implements OnInit {

  constructor() { }
  mensajeEmail: boolean = true
  ngOnInit(): void {

    var actual = window.location + '';
    //Se realiza la división de la URL
    var split = actual.split("/");
    //Se obtiene el ultimo valor de la URL
    var id = split[split.length - 1];

    if (id == "CONTRATO") {
      this.mensajeEmail = true;
    }else{
      this.mensajeEmail = false;
    }


  }

}
